import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Topics from "../pages/topics/page";
import TopicDetail from "../pages/topic/page";
import About from "../pages/about/page";
import Submit from "../pages/submit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/topics",
    element: <Topics />,
  },
  {
    path: "/topic/:id",
    element: <TopicDetail />,
  },
  {
    path: "/submit",
    element: <Submit />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;